<!--
    Define templates for content projection into components
    It will be up to the components to place these elements according to their needs
    See <ng-container>'s below where these templates are projected into the components.
-->
<ng-template #instructionsDiv>
    <div *ngIf="HasInstructions" style="margin-left:10px;display:block; margin-bottom:-15px;" [innerHtml]="FormField.instructionsText | preserveStyles"></div>
</ng-template>

<ng-template #tooltipDiv>
    <div *ngIf="this.HasTooltipText" class="tooltip-div">
        <mat-icon style="cursor:default" matTooltip="{{this.TooltipText}}">info</mat-icon>
    </div>
</ng-template>

<div *ngIf="true" class="flexbox-div">
    <!-- Use all of the remaining space to display the child form field component. -->
    <div *ngIf="(this.FieldDefinitionClassName !== undefined) && (this.FieldDefinitionClassName !== null) && (this.FieldDefinitionClassName !== '')" class="child-form-field-div">

        <!-- Define the wrapped component as an ng-template. -->
        <ng-container *ngIf="this.WrapperOperatingMode === 'Dynamic Component'">
            <ng-template dynamic-component-host name="formFieldDirective" #formFieldDirective></ng-template>
        </ng-container>
        <div class="{{fieldIsInGrid ? 'field-and-no-instructions' : 'instructions-and-field'}}" style="{{this.InstructionsAndFieldAdditionalStyling}}">

            <div *ngIf="this.ShowFieldTypeSelector">
                <mat-select class="field-type-selector" [(ngModel)]="this.FormField.fieldDefinitionClassName">
                    <mat-select-trigger title="{{GetFieldTypeTitle}}">
                        <mat-icon *ngIf="GetFormFieldTypeIconType == 'MatIcon'" mat-list-icon>{{GetFormFieldTypeIconName}}</mat-icon>
                        <mat-icon *ngIf="GetFormFieldTypeIconType == 'SvgIcon'" mat-list-icon svgIcon="{{GetFormFieldTypeIconName}}"></mat-icon>
                    </mat-select-trigger>
                    <mat-option *ngFor="let fieldType of FieldTypes"
                                [value]="fieldType.fieldDefinitionClassName"
                                title="{{fieldType.fieldName}}">
                        <mat-icon *ngIf="fieldType.iconType == 'MatIcon'">{{fieldType.iconName}}</mat-icon>
                        <mat-icon *ngIf="fieldType.iconType == 'SvgIcon'" svgIcon="{{fieldType.iconName}}"></mat-icon>
                        <span>{{fieldType.fieldName}}</span>
                    </mat-option>
                </mat-select>
            </div>

            <!-- Use a switch statement, the original code, to display the correct form field. -->
            <div *ngIf="this.WrapperOperatingMode === 'Static Component'"
                 [ngSwitch]="this.FieldDefinitionClassName"
                 class="form-field-div"
                 style="{{this.ChildFormFieldLayoutAdditionalStyling}}">

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.LabelFieldDefinition'"
                     class="form-field-wrapper-div">

                    <app-label-form-field [formField]="this.FormField"
                                          [mode]="this.FieldMode"
                                          [readOnly]="this.ReadOnly"
                                          [displayHints]="this.DispayHints"
                                          [fieldIsInGrid]="this.FieldIsInGrid"
                                          (onInit)="this.handleOnInitEvent($event)"
                                          [(ngModel)]="this.FormInstanceElement"
                                          (ngModelChange)="this.handleNgOnChange()"
                                          (contextmenu)="this.handleContextMenu($event)"></app-label-form-field>
                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.ShortTextFieldDefinition'" class="form-field-wrapper-div">
                    <app-short-text-form-field [formField]="this.FormField"
                                               [mode]="this.FieldMode"
                                               [readOnly]="this.ReadOnly"
                                               [displayHints]="this.DispayHints"
                                               [fieldIsInGrid]="this.FieldIsInGrid"
                                               [useGridSpecificStyling]="this.FieldIsInGrid"
                                               [(ngModel)]="this.FormInstanceElement"
                                               (ngModelChange)="this.handleNgOnChange()"
                                               (onInit)="this.handleOnInitEvent($event)"
                                               (contextmenu)="this.handleContextMenu($event)"
                                               (touched)="this.handleTouched($event)"
                                               (formFieldValidated)="this.handleFieldValidated($event)"
                                               (formControlCreated)="this.handleFormControlCreated($event)">
                        <!-- pharv - 4/14 added the touched event and handler. In future iteration use these to trigger validation updates -->
                        <ng-container projectedInstructions *ngTemplateOutlet="instructionsDiv"></ng-container>
                        <ng-container projectedTooltip *ngTemplateOutlet="tooltipDiv"></ng-container>
                    </app-short-text-form-field>
                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.ParagraphFieldDefinition'"
                     class="form-field-wrapper-div">
                    <!-- //VNEXT-561: KLW - Fix for instructions showing below paragraph field -->
                    <app-paragraph-form-field [formField]="this.FormField"
                                              [mode]="this.Mode"
                                              [readOnly]="this.ReadOnly"
                                              [displayHints]="this.DispayHints"
                                              [fieldIsInGrid]="this.FieldIsInGrid"
                                              (onInit)="this.handleOnInitEvent($event)"
                                              [(ngModel)]="this.FormInstanceElement"
                                              (ngModelChange)="this.handleNgOnChange()"
                                              (touched)="this.handleTouched($event)"
                                              (formFieldValidated)="this.handleFieldValidated($event)"
                                              (formControlCreated)="this.handleFormControlCreated($event)">
                        <ng-container projectedInstructions *ngTemplateOutlet="instructionsDiv"></ng-container>
                        <ng-container projectedTooltip *ngTemplateOutlet="tooltipDiv"></ng-container>
                    </app-paragraph-form-field>
                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.RichTextFieldDefinition'" class="form-field-wrapper-div">
                    <app-rich-text-form-field [formField]="this.FormField"
                                              [mode]="this.FieldMode"
                                              [readOnly]="this.ReadOnly"
                                              [displayHints]="this.DispayHints"
                                              [fieldIsInGrid]="this.FieldIsInGrid"
                                              [formInstance]="this.formInstance"
                                              (onInit)="this.handleOnInitEvent($event)"
                                              [(ngModel)]="this.FormInstanceElement"
                                              (ngModelChange)="this.handleNgOnChange()"
                                              (contextmenu)="this.handleContextMenu($event)"
                                              (touched)="this.handleTouched($event)"
                                              (formFieldValidated)="this.handleFieldValidated($event)"
                                              (formControlCreated)="this.handleFormControlCreated($event)">
                        <ng-container projectedInstructions *ngTemplateOutlet="instructionsDiv"></ng-container>
                        <ng-container projectedTooltip *ngTemplateOutlet="tooltipDiv"></ng-container>
                    </app-rich-text-form-field>
                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.DateFieldDefinition'"
                     class="form-field-wrapper-div">
                    <app-date-form-field [formField]="this.FormField"
                                         [mode]="this.FieldMode"
                                         [readOnly]="this.ReadOnly"
                                         [displayHints]="this.DispayHints"
                                         [fieldIsInGrid]="this.FieldIsInGrid"
                                         (onInit)="this.handleOnInitEvent($event)"
                                         [(ngModel)]="this.FormInstanceElement"
                                         (ngModelChange)="this.handleNgOnChange()"
                                         (contextmenu)="this.handleContextMenu($event)"
                                         (touched)="this.handleTouched($event)"
                                         (formFieldValidated)="this.handleFieldValidated($event)"
                                         (formControlCreated)="this.handleFormControlCreated($event)">
                        <ng-container projectedInstructions *ngTemplateOutlet="instructionsDiv"></ng-container>
                        <ng-container projectedTooltip *ngTemplateOutlet="tooltipDiv"></ng-container>
                    </app-date-form-field>
                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.CheckBoxFieldDefinition'">
                    <app-checkbox-form-field [formField]="this.FormField"
                                             [mode]="this.FieldMode"
                                             [readOnly]="this.ReadOnly"
                                             [displayHints]="this.DispayHints"
                                             [fieldIsInGrid]="this.FieldIsInGrid"
                                             (onInit)="this.handleOnInitEvent($event)"
                                             [(ngModel)]="this.FormInstanceElement"
                                             (ngModelChange)="this.handleNgOnChange()"
                                             (contextmenu)="this.handleContextMenu($event)"
                                             (touched)="this.handleTouched($event)"
                                             (formFieldValidated)="this.handleFieldValidated($event)"
                                             (formControlCreated)="this.handleFormControlCreated($event)">
                        <ng-container projectedInstructions *ngTemplateOutlet="instructionsDiv"></ng-container>
                        <ng-container projectedTooltip *ngTemplateOutlet="tooltipDiv"></ng-container>
                    </app-checkbox-form-field>
                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.RadioButtonFieldDefinition'"
                     class="form-field-wrapper-div">
                    <app-radio-buttons-form-field [formField]="this.FormField"
                                                  [mode]="this.FieldMode"
                                                  [readOnly]="this.ReadOnly"
                                                  [displayHints]="this.DispayHints"
                                                  [fieldIsInGrid]="this.FieldIsInGrid"
                                                  (onInit)="this.handleOnInitEvent($event)"
                                                  [(ngModel)]="this.FormInstanceElement"
                                                  (ngModelChange)="this.handleNgOnChange()"
                                                  (contextmenu)="this.handleContextMenu($event)"
                                                  (touched)="this.handleTouched($event)"
                                                  (formFieldValidated)="this.handleFieldValidated($event)"
                                                  (formControlCreated)="this.handleFormControlCreated($event)">
                        <ng-container projectedInstructions *ngTemplateOutlet="instructionsDiv"></ng-container>
                        <ng-container projectedTooltip *ngTemplateOutlet="tooltipDiv"></ng-container>
                    </app-radio-buttons-form-field>
                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.IntegerFieldDefinition'"
                     class="form-field-wrapper-div">
                    <app-integer-form-field [formField]="this.FormField"
                                            [mode]="this.FieldMode"
                                            [readOnly]="this.ReadOnly"
                                            [displayHints]="this.DispayHints"
                                            [fieldIsInGrid]="this.FieldIsInGrid"
                                            (onInit)="this.handleOnInitEvent($event)"
                                            [(ngModel)]="this.FormInstanceElement"
                                            (ngModelChange)="this.handleNgOnChange()"
                                            (contextmenu)="this.handleContextMenu($event)"
                                            (touched)="this.handleTouched($event)"
                                            (formFieldValidated)="this.handleFieldValidated($event)"
                                            (formControlCreated)="this.handleFormControlCreated($event)">
                        <ng-container projectedInstructions *ngTemplateOutlet="instructionsDiv"></ng-container>
                        <ng-container projectedTooltip *ngTemplateOutlet="tooltipDiv"></ng-container>
                    </app-integer-form-field>
                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.CurrencyFieldDefinition'"
                     class="form-field-wrapper-div">
                    <app-currency-form-field [formField]="this.FormField"
                                             [mode]="this.FieldMode"
                                             [readOnly]="this.ReadOnly"
                                             [displayHints]="this.DispayHints"
                                             [fieldIsInGrid]="this.FieldIsInGrid"
                                             (onInit)="this.handleOnInitEvent($event)"
                                             [(ngModel)]="this.FormInstanceElement"
                                             (ngModelChange)="this.handleNgOnChange()"
                                             (contextmenu)="this.handleContextMenu($event)"
                                             (touched)="this.handleTouched($event)"
                                             (formFieldValidated)="this.handleFieldValidated($event)"
                                             (formControlCreated)="this.handleFormControlCreated($event)">
                        <ng-container projectedInstructions *ngTemplateOutlet="instructionsDiv"></ng-container>
                        <ng-container projectedTooltip *ngTemplateOutlet="tooltipDiv"></ng-container>
                    </app-currency-form-field>
                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.DecimalFieldDefinition'"
                     class="form-field-wrapper-div">
                    <app-decimal-form-field [formField]="this.FormField"
                                            [mode]="this.FieldMode"
                                            [readOnly]="this.ReadOnly"
                                            [displayHints]="this.DispayHints"
                                            [fieldIsInGrid]="this.FieldIsInGrid"
                                            (onInit)="this.handleOnInitEvent($event)"
                                            [(ngModel)]="this.FormInstanceElement"
                                            (ngModelChange)="this.handleNgOnChange()"
                                            (contextmenu)="this.handleContextMenu($event)"
                                            (touched)="this.handleTouched($event)"
                                            (formFieldValidated)="this.handleFieldValidated($event)"
                                            (formControlCreated)="this.handleFormControlCreated($event)">
                        <ng-container projectedInstructions *ngTemplateOutlet="instructionsDiv"></ng-container>
                        <ng-container projectedTooltip *ngTemplateOutlet="tooltipDiv"></ng-container>
                    </app-decimal-form-field>
                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.DropDownFieldDefinition'"
                     class="form-field-wrapper-div">
                    <app-drop-down-form-field [formField]="this.FormField"
                                              [mode]="this.FieldMode"
                                              [readOnly]="this.ReadOnly"
                                              [displayHints]="this.DispayHints"
                                              [fieldIsInGrid]="this.FieldIsInGrid"
                                              (onInit)="this.handleOnInitEvent($event)"
                                              (onPropertyUpdated)="this.handleOnPropertyUpdated($event)"
                                              [(ngModel)]="this.FormInstanceElement"
                                              (ngModelChange)="this.handleNgOnChange()"
                                              (contextmenu)="this.handleContextMenu($event)"
                                              (touched)="this.handleTouched($event)"
                                              (formFieldValidated)="this.handleFieldValidated($event)"
                                              (formControlCreated)="this.handleFormControlCreated($event)">
                        <ng-container projectedInstructions *ngTemplateOutlet="instructionsDiv"></ng-container>
                        <ng-container projectedTooltip *ngTemplateOutlet="tooltipDiv"></ng-container>
                    </app-drop-down-form-field>
                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.FlexibleSelectionFieldDefinition'" class="form-field-wrapper-div">
                    <!-- Note: Wait to render the field until its options have been defined (since these are set via an async call on Form Instance load)-->
                    <!-- <span *ngIf="this.FormField.selectOptions == null">Loading...</span> -->
                    <app-flexible-selection-form-field *ngIf="this.FieldMode == 'design' || this.FormField.selectOptions !== null"
                                                       [formField]="this.FormField"
                                                       [formInstance]="this.FormInstance"
                                                       [mode]="this.FieldMode"
                                                       [readOnly]="this.ReadOnly"
                                                       [displayHints]="this.DispayHints"
                                                       [fieldIsInGrid]="this.FieldIsInGrid"
                                                       [gridRowId]="this.GridRowId"
                                                       [gridColumnDefs]="this.GridColumnDefs"
                                                       (onInit)="this.handleOnInitEvent($event)"
                                                       (onPropertyUpdated)="this.handleOnPropertyUpdated($event)"
                                                       [(ngModel)]="this.FormInstanceElement"
                                                       (ngModelChange)="this.handleNgOnChange()"
                                                       (mimickedNgModelChange)="this.reEmitMimickedNgModelChange($event)"
                                                       (contextmenu)="this.handleContextMenu($event)"
                                                       (touched)="this.handleTouched($event)"
                                                       (formFieldValidated)="this.handleFieldValidated($event)"
                                                       (formControlCreated)="this.handleFormControlCreated($event)">
                        <ng-container projectedInstructions *ngTemplateOutlet="instructionsDiv"></ng-container>
                        <ng-container projectedTooltip *ngTemplateOutlet="tooltipDiv"></ng-container>
                    </app-flexible-selection-form-field>
                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.FlexFieldButtonsFieldDefinition'" class="form-field-wrapper-div">
                    <app-flex-field-buttons-form-field [formField]="this.FormField"
                                                       [formInstance]="this.FormInstance"
                                                       [mode]="this.FieldMode"
                                                       [readOnly]="this.ReadOnly"
                                                       [displayHints]="this.DispayHints"
                                                       [fieldIsInGrid]="this.FieldIsInGrid"
                                                       [gridRowId]="this.GridRowId"
                                                       [gridColumnDefs]="this.GridColumnDefs"
                                                       (onInit)="this.handleOnInitEvent($event)"
                                                       (onPropertyUpdated)="this.handleOnPropertyUpdated($event)"
                                                       [(ngModel)]="this.FormInstanceElement"
                                                       (ngModelChange)="this.handleNgOnChange()"
                                                       (mimickedNgModelChange)="this.reEmitMimickedNgModelChange($event)"
                                                       (contextmenu)="this.handleContextMenu($event)"
                                                       (touched)="this.handleTouched($event)"
                                                       (formFieldValidated)="this.handleFieldValidated($event)"
                                                       (formControlCreated)="this.handleFormControlCreated($event)">
                        <ng-container projectedInstructions *ngTemplateOutlet="instructionsDiv"></ng-container>
                        <ng-container projectedTooltip *ngTemplateOutlet="tooltipDiv"></ng-container>
                    </app-flex-field-buttons-form-field>
                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.GridFieldDefinition'" class="form-field-wrapper-div">
                    <app-grid-form-field [formField]="this.FormField"
                                         [formInstance]="this.FormInstance"
                                         [mode]="this.FieldMode"
                                         [readOnly]="this.ReadOnly"
                                         [displayHints]="this.DispayHints"
                                         (onInit)="this.handleOnInitEvent($event)"
                                         (onEdit)="this.handleGridEditColumnPropertiesEvent($event)"
                                         [(ngModel)]="this.FormInstanceElement"
                                         (ngModelChange)="this.handleNgOnChange()"
                                         (designChange)="this.handleFieldDesignChange()"
                                         (mainGridValidation)="this.handleFieldValidated($event)"
                                         (formFieldValidated)="this.handleFieldValidated($event)"
                                         (loadFormInstanceElement)="this.handleLoadFormInstanceElement($event)"
                                         (conditionalLogicInstructions)="this.handleConditionalLogicInstructions($event)">
                        <ng-container projectedInstructions *ngTemplateOutlet="instructionsDiv"></ng-container>
                        <!-- no tooltip since each individual field that comprise a grid handle their own tooltips -->
                    </app-grid-form-field>
                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.CascadingDropDownFieldDefinition'"
                     class="form-field-wrapper-div">
                    <app-cascading-drop-down-form-field [formField]="this.FormField"
                                                        [mode]="this.FieldMode"
                                                        [readOnly]="this.ReadOnly"
                                                        [displayHints]="this.DispayHints"
                                                        (onInit)="this.handleOnInitEvent($event)"
                                                        [(ngModel)]="this.FormInstanceElement"
                                                        (touched)="this.handleTouched($event)"
                                                        (ngModelChange)="this.handleNgOnChange()"
                                                        (contextmenu)="this.handleContextMenu($event)">
                        <ng-container projectedInstructions *ngTemplateOutlet="instructionsDiv"></ng-container>
                        <ng-container projectedTooltip *ngTemplateOutlet="tooltipDiv"></ng-container>
                    </app-cascading-drop-down-form-field>

                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.GridCascadingDropDownFieldDefinition'"
                     class="form-field-wrapper-div">
                    <app-grid-cascading-dropdown-form-field [formField]="this.FormField"
                                                            [mode]="this.FieldMode"
                                                            [readOnly]="this.ReadOnly"
                                                            [displayHints]="this.DispayHints"
                                                            [fieldIsInGrid]="this.FieldIsInGrid"
                                                            (onInit)="this.handleOnInitEvent($event)"
                                                            [(ngModel)]="this.FormInstanceElement"
                                                            (ngModelChange)="this.handleNgOnChange()"
                                                            (contextmenu)="this.handleContextMenu($event)">
                        <ng-container projectedInstructions *ngTemplateOutlet="instructionsDiv"></ng-container>
                        <ng-container projectedTooltip *ngTemplateOutlet="tooltipDiv"></ng-container>
                    </app-grid-cascading-dropdown-form-field>

                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.AttachmentFieldDefinition'" class="form-field-wrapper-div">
                    <!-- Added [formInstance]="this.formInstance" for VNEXT-1155 (new attachments field) -->
                    <app-attachment-form-field [formField]="this.FormField"
                                               [formInstance]="this.formInstance"
                                               [mode]="this.FieldMode"
                                               [readOnly]="this.ReadOnly"
                                               [displayHints]="this.DispayHints"
                                               (onEdit)="this.handleGridEditColumnPropertiesEvent($event)"
                                               (onInit)="this.handleOnInitEvent($event)"
                                               [(ngModel)]="this.FormInstanceElement"
                                               (ngModelChange)="this.handleNgOnChange()"
                                               (contextmenu)="this.handleContextMenu($event)"
                                               (requestFormInstanceIds)="this.handleRequestFormInstanceIds($event)">
                        <ng-container projectedInstructions *ngTemplateOutlet="instructionsDiv"></ng-container>
                        <ng-container projectedTooltip *ngTemplateOutlet="tooltipDiv"></ng-container>
                    </app-attachment-form-field>

                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.FormulaFieldDefinition'" class="form-field-wrapper-div">
                    <!-- pharv - 8/2/23 for VNEXT 778 - added [calculatedValue]="this.FormInstanceElement.doubleValue" to set an initial value -->
                    <app-formula-form-field [formField]="this.FormField"
                                            [calculatedValue]="this.FormInstanceElement.doubleValue"
                                            [mode]="this.FieldMode"
                                            [readOnly]="this.ReadOnly"
                                            [displayHints]="this.DispayHints"
                                            [fieldIsInGrid]="this.FieldIsInGrid"
                                            (onInit)="this.handleOnInitEvent($event)"
                                            [(ngModel)]="this.FormInstanceElement"
                                            (ngModelChange)="this.handleNgOnChange()"
                                            (contextmenu)="this.handleContextMenu($event)">
                        <ng-container *ngTemplateOutlet="instructionsDiv"></ng-container>
                    </app-formula-form-field>

                </div>
                <!-- Added for VNEXT-1419 - dynamic url builder -->
                <!-- Took out [(ngModel)]="this.FormInstanceElement" to work around errors -->
                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.ValueConcatenatorFieldDefinition'" class="form-field-wrapper-div">
                    <app-value-concatenator-form-field [formField]="this.FormField"
                                                [mode]="this.FieldMode"
                                                [readOnly]="this.ReadOnly"
                                                [displayHints]="this.DispayHints"
                                                [fieldIsInGrid]="this.FieldIsInGrid"
                                                [useGridSpecificStyling]="this.FieldIsInGrid"
                                                [(ngModel)]="this.FormInstanceElement"
                                                (ngModelChange)="this.handleNgOnChange()"
                                                (onInit)="this.handleOnInitEvent($event)"
                                                (contextmenu)="this.handleContextMenu($event)"
                                                (touched)="this.handleTouched($event)"
                                                (formFieldValidated)="this.handleFieldValidated($event)"
                                                (formControlCreated)="this.handleFormControlCreated($event)">
                        <ng-container projectedInstructions *ngTemplateOutlet="instructionsDiv"></ng-container>
                        <ng-container projectedTooltip *ngTemplateOutlet="tooltipDiv"></ng-container>
                    </app-value-concatenator-form-field>
                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.RawHTMLFieldDefinition'"
                     class="form-field-wrapper-div">

                    <app-raw-html-form-field [formField]="this.FormField"
                                             [mode]="this.FieldMode"
                                             [readOnly]="this.ReadOnly"
                                             [displayHints]="this.DispayHints"
                                             [fieldIsInGrid]="this.FieldIsInGrid"
                                             (onInit)="this.handleOnInitEvent($event)"
                                             [(ngModel)]="this.FormInstanceElement"
                                             (ngModelChange)="this.handleNgOnChange()"
                                             (contextmenu)="this.handleContextMenu($event)">

                    </app-raw-html-form-field>

                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.InlineContentFieldDefinition'"
                     class="form-field-wrapper-div">

                    <app-inline-content-form-field [formField]="this.FormField"
                                                   [formInstance]="this.FormInstance"
                                                   [mode]="this.FieldMode"
                                                   [readOnly]="this.ReadOnly"
                                                   [displayHints]="this.DispayHints"
                                                   (onInit)="this.handleOnInitEvent($event)"
                                                   [(ngModel)]="this.FormInstanceElement"
                                                   (ngModelChange)="this.handleNgOnChange()"
                                                   (contextmenu)="this.handleContextMenu($event)">

                    </app-inline-content-form-field>

                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.MultiCheckBoxFieldDefinition'" class="form-field-wrapper-div">
                    <app-multi-checkbox-form-field [formField]="this.FormField"
                                                   [mode]="this.FieldMode"
                                                   [readOnly]="this.ReadOnly"
                                                   [displayHints]="this.DispayHints"
                                                   [fieldIsInGrid]="this.FieldIsInGrid"
                                                   (onInit)="this.handleOnInitEvent($event)"
                                                   [(ngModel)]="this.FormInstanceElement"
                                                   (ngModelChange)="this.handleNgOnChange()"
                                                   (contextmenu)="this.handleContextMenu($event)"
                                                   (touched)="this.handleTouched($event)"
                                                   (formFieldValidated)="this.handleFieldValidated($event)"
                                                   (formControlCreated)="this.handleFormControlCreated($event)">
                        <ng-container projectedInstructions *ngTemplateOutlet="instructionsDiv"></ng-container>
                        <ng-container projectedTooltip *ngTemplateOutlet="tooltipDiv"></ng-container>
                    </app-multi-checkbox-form-field>

                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.MultiDropDownFieldDefinition'"
                     class="form-field-wrapper-div">

                    <app-multi-drop-down-form-field [formField]="this.FormField"
                                                    [mode]="this.FieldMode"
                                                    [readOnly]="this.ReadOnly"
                                                    [displayHints]="this.DispayHints"
                                                    [fieldIsInGrid]="this.FieldIsInGrid"
                                                    (onInit)="this.handleOnInitEvent($event)"
                                                    (formFieldValidated)="this.handleFieldValidated($event)"
                                                    (formControlCreated)="this.handleFormControlCreated($event)"
                                                    (onPropertyUpdated)="this.handleOnPropertyUpdated($event)"
                                                    (mimickedNgModelChange)="this.reEmitMimickedNgModelChange($event)"
                                                    [(ngModel)]="this.FormInstanceElement"
                                                    (touched)="this.handleTouched($event)"
                                                    (ngModelChange)="this.handleNgOnChange()"
                                                    (contextmenu)="this.handleContextMenu($event)">
                        <ng-container projectedInstructions *ngTemplateOutlet="instructionsDiv"></ng-container>
                        <ng-container projectedTooltip *ngTemplateOutlet="tooltipDiv"></ng-container>
                    </app-multi-drop-down-form-field>

                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.ContactsFieldDefinition'">
                    <!-- Added [formInstance]="this.formInstance" for VNEXT-1100 (new contacts field)-->
                    <app-contacts-form-field [formField]="this.FormField"
                                             [formInstance]="this.formInstance"
                                             [mode]="this.FieldMode"
                                             [readOnly]="this.ReadOnly"
                                             [displayHints]="this.DispayHints"
                                             [formInstanceName]="this.FormInstanceName"
                                             (onInit)="this.handleOnInitEvent($event)"
                                             (onEdit)="this.handleGridEditColumnPropertiesEvent($event)"
                                             [(ngModel)]="this.FormInstanceElement"
                                             (ngModelChange)="this.handleNgOnChange()"
                                             (contextmenu)="this.handleContextMenu($event)"
                                             (displayError)="this.handleDisplayError($event)">
                        <ng-container projectedInstructions *ngTemplateOutlet="instructionsDiv"></ng-container>
                        <ng-container projectedTooltip *ngTemplateOutlet="tooltipDiv"></ng-container>
                    </app-contacts-form-field>

                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.CommentsFieldDefinition'">
                    <app-comments-form-field [formField]="this.FormField"
                                             [mode]="this.FieldMode"
                                             [readOnly]="this.ReadOnly"
                                             [displayHints]="this.DispayHints"
                                             (onInit)="this.handleOnInitEvent($event)"
                                             [(ngModel)]="this.FormInstanceElement"
                                             (ngModelChange)="this.handleNgOnChange()"
                                             (contextmenu)="this.handleContextMenu($event)"
                                             (displayError)="this.handleDisplayError($event)">
                        <ng-container projectedInstructions *ngTemplateOutlet="instructionsDiv"></ng-container>
                        <ng-container projectedTooltip *ngTemplateOutlet="tooltipDiv"></ng-container>
                    </app-comments-form-field>
                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.VisibilityShowToFieldDefinition'">
                    <app-show-to-hide-from [formField]="this.FormField"
                                           [mode]="this.FieldMode"
                                           [readOnly]="this.ReadOnly"
                                           [displayHints]="this.DispayHints"
                                           (onInit)="this.handleOnInitEvent($event)"
                                           [(ngModel)]="this.FormInstanceElement"
                                           (ngModelChange)="this.handleNgOnChange()"
                                           (contextmenu)="this.handleContextMenu($event)"
                                           (touched)="this.handleTouched($event)">
                    </app-show-to-hide-from>
                </div>
                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.VisibilityHideFromFieldDefinition'">
                    <app-show-to-hide-from [formField]="this.FormField"
                                           [mode]="this.FieldMode"
                                           [readOnly]="this.ReadOnly"
                                           [displayHints]="this.DispayHints"
                                           (onInit)="this.handleOnInitEvent($event)"
                                           [(ngModel)]="this.FormInstanceElement"
                                           (ngModelChange)="this.handleNgOnChange()"
                                           (contextmenu)="this.handleContextMenu($event)"
                                           (touched)="this.handleTouched($event)">
                    </app-show-to-hide-from>
                </div>
                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.VisibilityMarkDataReadOnlyFieldDefinition'">
                    <app-mark-data-readonly [formField]="this.FormField"
                                            [mode]="this.FieldMode"
                                            [readOnly]="this.ReadOnly"
                                            [displayHints]="this.DispayHints"
                                            (onInit)="this.handleOnInitEvent($event)"
                                            [(ngModel)]="this.FormInstanceElement"
                                            (ngModelChange)="this.handleNgOnChange()"
                                            (contextmenu)="this.handleContextMenu($event)"
                                            (touched)="this.handleTouched($event)">
                    </app-mark-data-readonly>
                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.FormTemplateInstancesFieldDefinition'">
                    <app-form-template-instances [formField]="this.FormField"
                                                 [mode]="this.FieldMode"
                                                 [readOnly]="this.ReadOnly"
                                                 [displayHints]="this.DispayHints"
                                                 (onInit)="this.handleOnInitEvent($event)"
                                                 [(ngModel)]="this.FormInstanceElement"
                                                 (ngModelChange)="this.handleNgOnChange()"
                                                 (contextmenu)="this.handleContextMenu($event)"
                                                 (newFormInstanceCreated)="this.handleNewObjectCreated($event)"
                                                 (touched)="this.handleTouched($event)">
                    </app-form-template-instances>
                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.HtmlLinkFieldDefinition'">
                    <app-html-link-field [formField]="this.FormField"
                                         [mode]="this.FieldMode"
                                         [readOnly]="this.ReadOnly"
                                         [displayHints]="this.DispayHints"
                                         [fieldIsInGrid]="this.FieldIsInGrid"
                                         [useGridSpecificStyling]="this.FieldIsInGrid"
                                         [(ngModel)]="this.FormInstanceElement"
                                         (ngModelChange)="this.handleNgOnChange()"
                                         (onInit)="this.handleOnInitEvent($event)"
                                         (contextmenu)="this.handleContextMenu($event)"
                                         (touched)="this.handleTouched($event)"
                                         (formFieldValidated)="this.handleFieldValidated($event)"
                                         (formControlCreated)="this.handleFormControlCreated($event)">
                        <!--VNEXT-984: KLW - Fixing issue where instructions weren't showing -->
                        <ng-container projectedInstructions *ngTemplateOutlet="instructionsDiv"></ng-container>
                    </app-html-link-field>
                </div>

                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.TelerikHtmlEditorFieldDefinition'">
                    <app-telerik-html-editor [formField]="this.FormField"
                                             [mode]="this.FieldMode"
                                             [readOnly]="this.ReadOnly"
                                             [displayHints]="this.DispayHints"
                                             [formInstanceName]="this.FormInstanceName"
                                             (onInit)="this.handleOnInitEvent($event)"
                                             [(ngModel)]="this.FormInstanceElement"
                                             (ngModelChange)="this.handleNgOnChange()"
                                             (contextmenu)="this.handleContextMenu($event)"
                                             (displayError)="this.handleDisplayError($event)">
                        <ng-container projectedInstructions *ngTemplateOutlet="instructionsDiv"></ng-container>
                        <ng-container projectedTooltip *ngTemplateOutlet="tooltipDiv"></ng-container>
                    </app-telerik-html-editor>
                </div>

                <div *ngSwitchDefault>

                </div>

                <!--TEAMS-424: KLW - Have the footnote form field show when its parent has the annotation-->
                <div *ngIf="this.FormField.HasFootnote"
                     class="form-field-wrapper-div">
                    <app-footnote-form-field [formField]="this.FormField"
                                             [mode]="this.FieldMode"
                                             [readOnly]="this.ReadOnly"
                                             [displayHints]="this.DispayHints"
                                             (onInit)="this.handleFootnoteOnInitEvent($event)"
                                             [(ngModel)]="this.FormInstanceElement"
                                             (ngModelChange)="this.handleNgOnChange()"></app-footnote-form-field>
                </div>

                <!--Editor Name field-->
                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.EditorNameFieldDefinition'"
                     class="form-field-wrapper-div">

                    <app-editor-name-form-field [formField]="this.FormField"
                                                [mode]="this.FieldMode"
                                                [readOnly]="this.ReadOnly"
                                                [displayHints]="this.DispayHints"
                                                [fieldIsInGrid]="this.FieldIsInGrid"
                                                [useGridSpecificStyling]="this.FieldIsInGrid"
                                                (onInit)="this.handleOnInitEvent($event)"
                                                [(ngModel)]="this.FormInstanceElement"
                                                (ngModelChange)="this.handleNgOnChange()"
                                                (contextmenu)="this.handleContextMenu($event)"
                                                (touched)="this.handleTouched($event)"
                                                (formFieldValidated)="this.handleFieldValidated($event)"
                                                (formControlCreated)="this.handleFormControlCreated($event)">
                        <ng-container projectedTooltip *ngTemplateOutlet="tooltipDiv"></ng-container>
                    </app-editor-name-form-field>
                </div>

                <!--Last Edited Date field-->
                <div *ngSwitchCase="'Collect.vNext.FieldDefinitions.LastEditedDateFieldDefinition'"
                     class="form-field-wrapper-div">

                    <app-last-edited-date-form-field [formField]="this.FormField"
                                                     [mode]="this.FieldMode"
                                                     [readOnly]="this.ReadOnly"
                                                     [displayHints]="this.DispayHints"
                                                     [fieldIsInGrid]="this.FieldIsInGrid"
                                                     [useGridSpecificStyling]="this.FieldIsInGrid"
                                                     (onInit)="this.handleOnInitEvent($event)"
                                                     [(ngModel)]="this.FormInstanceElement"
                                                     (ngModelChange)="this.handleNgOnChange()"
                                                     (contextmenu)="this.handleContextMenu($event)"
                                                     (touched)="this.handleTouched($event)"
                                                     (formFieldValidated)="this.handleFieldValidated($event)"
                                                     (formControlCreated)="this.handleFormControlCreated($event)">
                        <ng-container projectedTooltip *ngTemplateOutlet="tooltipDiv"></ng-container>
                    </app-last-edited-date-form-field>
                </div>
            </div>
        </div>

        <!-- Display any form field error messages. -->
        <!-- <ng-container> -->
        <!--<mat-error *ngIf="(!this.FormInstanceIsSaving) && (this.WrappedFormComponent?.getValidationErrors(revealValidationErrors)?.length > 0)" class="child-error-message">-->
        <mat-error #errorDiv class="child-error-message">
            <ul class="error-list">
                <!--*ngFor="let msg of this.WrappedFormComponent?.getValidationErrors(revealValidationErrors)"-->
                <ng-container>
                    <li #validationErrorMessage></li>
                </ng-container>
            </ul>
        </mat-error>
        <!-- </ng-container> -->
    </div>

    <!-- Display an edit icon on the right of this flexbox div. -->
    <div *ngIf="(this.Mode === 'design') || (this.Mode === 'gridDesign')"
         class="edit-icon-container-div">
        <div *ngIf="this.DisplayFormFieldPropertiesEdit"
             class="edit-icon-div">
            <mat-icon aria-hidden="false"
                      aria-label="Edit short text properties"
                      (click)="this.handleEditPropertiesClickEvent()"
                      (contextmenu)="this.handleContextMenu($event)"
                      matTooltip="{{this.TooltipText}}"
                      [matTooltipPosition]="this.TooltipPosition">
                create
            </mat-icon>

            <!--
                <mat-icon *ngIf="this.ShowFormConditionalLogic"
                          svgIcon="predicate-logic-2"
                          class="form-conditional-logic-mat-icon"
                          aria-hidden="false"
                          aria-label="Form conditional logic"
                          (click)="this.fieldConditionalLogicClick()"></mat-icon>
             -->
        </div>
    </div>

</div>


